<template>
  <footer class="main-footer">
    <div class="footer-content">
      <div class="footer-col brand-col">
        <div class="footer-logo-area">
            <img src="/logo-192.png" alt="logo" class="footer-logo-img" />
            <span class="footer-brand-name">에드가말로</span>
        </div>
        <p class="footer-desc">세상의 모든 지식을 연결하고,<br />새로운 가치를 창조하는<br />크리에이티브 랩.</p>
      </div>
      
      <div class="footer-col">
        <h4>탐험 & 경험</h4>
        <ul>
          <li><router-link to="/journey">여정 (발견)</router-link></li>
          <li><router-link to="/mining">누리 (피드)</router-link></li>
          <li><router-link to="/favorites">갈무리 (보관함)</router-link></li>
          <li><router-link to="/quiz">슬기 (일반 퀴즈)</router-link></li>
          <li><router-link to="/speedquiz">재치 (스피드 퀴즈)</router-link></li>
          <li><router-link to="/scratch">야금 (스크래치)</router-link></li>
          <li><router-link to="/silmari">실마리 (추리)</router-link></li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>공방 (Studio)</h4>
        <ul>
          <li><router-link to="/mystery">추리사건의 전말</router-link></li>
          <li><router-link to="/receipt">욕망의 편의점</router-link></li>
          <li><router-link to="/award">뻔뻔한 위원회</router-link></li>
          <li><router-link to="/chimpanzee">침팬지보다 낫겠지</router-link></li>
          <li><router-link to="/math-give-up">수포자 5초 전</router-link></li>
          <li><router-link to="/auth-code">인증번호 외우기</router-link></li>
          <li><router-link to="/physical-exam">디지털 신체검사</router-link></li>
          <li><router-link to="/cant-match">그걸 못 맞춰?</router-link></li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>지원 & 문의</h4>
        <ul>
          <li><router-link to="/notice">공지사항</router-link></li>
          <li><router-link to="/qna">문의 하기</router-link></li>
          <li><router-link to="/partnership">비즈니스 제휴</router-link></li>
          <li><router-link to="/devinquiry">개발 문의</router-link></li>
        </ul>
      </div>

      <div class="footer-col">
        <h4>약관 및 정책</h4>
        <ul>
          <li><a href="https://api.malomanlab.com/terms" target="_blank">서비스 이용약관</a></li>
          <li><a href="https://api.malomanlab.com/privacy" target="_blank"><strong>개인정보 처리방침</strong></a></li>
        </ul>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>&copy; 2025 Malomanlab(Edgarmalo). All rights reserved.</p>
    </div>
  </footer>
</template>

<style scoped>
.main-footer { 
  /* ⭐️ [최적화 1] 배경색을 더 진하게 하고, 블러 제거 */
  background-color: #050510; 
  border-top: 1px solid rgba(255, 255, 255, 0.05); 
  padding: 80px 20px 40px 20px; 
  color: #7f8c8d; 
  
  /* ⭐️ [최적화 2] 화면에 보일 때만 렌더링 (초기 로딩/스크롤 성능 향상) */
  content-visibility: auto; 
  
  /* ⭐️ [최적화 3] 레이아웃 격리 */
  contain: content;
}

.footer-content { 
  max-width: 1200px; 
  margin: 0 auto; 
  display: grid; 
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr; 
  gap: 30px; 
  margin-bottom: 60px; 
}
.footer-logo-area { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
.footer-logo-img { width: 24px; height: 24px; object-fit: contain; }
.footer-brand-name { font-size: 1.4rem; font-weight: 800; color: #fff; }
.footer-desc { line-height: 1.6; font-size: 0.95rem; }
.footer-col h4 { color: #fff; font-size: 1.1rem; margin-bottom: 20px; font-weight: 700; }
.footer-col ul { list-style: none; padding: 0; margin: 0; }
.footer-col ul li { margin-bottom: 12px; }
.footer-col ul li a { 
  color: #7f8c8d; 
  transition: color 0.2s; 
  font-size: 0.95rem; 
  text-decoration: none; 
}
.footer-col ul li a:hover { color: #ff4d4d; }

.footer-bottom { 
  max-width: 1200px; 
  margin: 0 auto; 
  border-top: 1px solid rgba(255, 255, 255, 0.05); 
  padding-top: 30px; 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  font-size: 0.9rem; 
}

/* 모바일 및 태블릿 반응형 처리 */
@media (max-width: 900px) {
  .footer-content { 
    grid-template-columns: 1fr 1fr; 
    gap: 40px;
  }
  .brand-col { 
    grid-column: span 2; 
    margin-bottom: 10px; 
  }
}

@media (max-width: 600px) {
  .footer-content { 
    grid-template-columns: 1fr; 
    text-align: center; 
    gap: 30px; 
  }
  .brand-col { grid-column: span 1; }
  .footer-logo-area { justify-content: center; }
  .footer-bottom { 
    flex-direction: column; 
    gap: 20px; 
  }
}
</style>